module.exports = __webpack_public_path__ + "img/medal.9d512ad0.png";